   
<template>
    <div>
        <a-card title="告警统计" >
          <v-gobackbutton slot="extra" >返回</v-gobackbutton>
        <a-form layout="inline" @submit="handleSubmit" :form="form">

            <a-form-model-item  label="请选择日期" prop="searchTimeRange">
            <a-popover v-model="rangevisible" trigger="click" placement="bottom" class="search_range">
                        <template slot="title">
                            <a-input v-model="searchTimeRange" placeholder="" class="date_input date_content" />
                        </template>
                        <template slot="content">
                            <div class="date_content">
                                <a-button type="link" @click="handleTime(1)">今天</a-button>
                                <a-button type="link" @click="handleTime(2)">昨天</a-button>
                                <a-button type="link" @click="handleTime(3)">本周</a-button>
                                <a-button type="link" @click="handleTime(4)">上周</a-button>
                                <a-button type="link" @click="handleTime(5)">本月</a-button>
                                <a-button type="link" @click="handleTime(6)">上月</a-button>
                                <a-button type="link" @click="handleTime(100)">自定义</a-button>

                            </div>
                        </template>
                        <a-button type="normal" style="color:#0070cc" :title="searchTimeRange">
                            {{dateTypeTitle}}
                            <a-icon type="down" style="color: #0070cc" />
                        </a-button>
                    </a-popover>
            </a-form-model-item>
            <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
            </a-form-item>

        </a-form>
  
        <a-tabs type="card"  default-active-key="errorcode" @change="callback" style="top:10px;">

            <a-tab-pane key="failrate" tab="失败率" force-render>
                <a-tabs type="card" default-active-key="failnumber" @change="callbackType">
                    <a-tab-pane key="failnumber" tab="按异常数">  </a-tab-pane>
                    <a-tab-pane key="failrate" tab="按失败率">  </a-tab-pane>
                </a-tabs>
            </a-tab-pane>

            <a-tab-pane key="timeout" tab="超时">
                <a-tabs type="card" default-active-key="failnumber" @change="callbackType">
                      <a-tab-pane key="failnumber" tab="按异常数">  </a-tab-pane>
                      <a-tab-pane key="failrate" tab="按失败率">  </a-tab-pane>
                </a-tabs>
            </a-tab-pane>


        </a-tabs>

         <div  id="chartname2" style="padding-right:20px;border:1px solid gray;top:10px;"> </div>

       </a-card>
    </div>
          
</template>

<script>
import { mapState } from "vuex";


const data_failrate = [];
const data_timeout = [];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            logstorename:'',
            projectname:'',
            dateTypeTitle:'今天',
            rangevisible:false,
            searchTimeRange:'',
            syslist:[],
            total:0,
            pageSize:5,
            page:undefined,
            errorcodeChart:null,
            errorcodeDetailChart:null,
            failrateChart:null,
            timeoutChart:null,
            sumData:[],
            errorDataList:[],
            errorDataDetailList:[],
            failerateDataList:null,
            timeoutDataList:[],
            chartDetail:null,
            data_failrate,
            data_timeout,
            tLoading:false,
            chartSys:null,
            chartSys_1:null,
            key1:'failrate',
            key2:'failnumber',
            starttime:'',
            endtime:'',
        }
    },
    methods: {

        handleSubmit(e){
            e.preventDefault();
            const {query} = this.$route;
            this.drawLine('failrate','',query)
        },

        handleSearch(){
            this.callback(this.key1);
        },
        
        handleSearchReset(){
            // this.$store.dispatch({
            //     type: "alarmmanager/getEmptySearch",
            //     showMsg: true
            // })
            // this.searchP.starttime=this.dateFormat('YYYY-mm-dd',new Date());
            // this.searchP.endtime=this.dateFormat('YYYY-mm-dd',new Date());
            // this.logstorename='';
            // this.handleTime(1);
        },
 

        handleTime(t){
            let cRange = {};
            if(t != 100){
                cRange = this.G.getRecentDate(t)
                this.dateTypeTitle = cRange.title;
                this.searchTimeRange = cRange.start_time + '~' + cRange.end_time;
                this.hide();

            }
            else{
                cRange = this.G.getRecentDate(7)
                this.searchTimeRange = cRange.start_time + '~' + cRange.end_time;
                this.dateTypeTitle = "自定义"
            }
        },

        handleTimeJump(t,searchTime){
            let cRange = {};
            if(t != 100){
                cRange = this.G.getRecentDate(t)
                this.dateTypeTitle = cRange.title;
                this.searchTimeRange = cRange.start_time + '~' + cRange.end_time;
                this.hide();

            }
            else{
                this.searchTimeRange =searchTime;
                this.dateTypeTitle = "自定义"
            }
        },

        hide() {
            this.rangevisible = false;
        },

        //上级按钮
        callback(key1) {
            console.log("callback===>"+key1);
            this.key1=key1;
            this.key2='failnumber';
            this.drawLine(key1,this.key2);
        },
        
        //下级按钮
        callbackType(key2) {
            console.log("callbackType===>"+key2);
            this.key2=key2;
            this.drawLine(this.key1,key2);
        },

        drawLine(key,keyType) {
            console.log("drawLine===>"+key+"_____________"+keyType);
            const {query} = this.$route;
            let that = this;
            let c_params = query;

            if(key==''){
                key='failrate'
            }
            if(keyType==''){
                keyType='failnumber'
            }
            if(query.serviceurl){
                this.serverurldetails='0'
            }else{
                this.serverurldetails='1'
            }
            if(key=='failrate'){// 失败率
                c_params = {
                    errorType:'2',
                    keyType:keyType,
                    appcode:query.appcode,
                    serviceurl:query.serviceurl,
                    urlparams:false,
                    serverurldetails:this.serverurldetails
                }

            }else if(key=='timeout'){ // 超时
                c_params = {
                    errorType:'3',
                    keyType:keyType,
                    urlparams:false,
                    appcode:query.appcode,
                    serviceurl:query.serviceurl,
                    serverurldetails:this.serverurldetails
                }
            }
            console.log("查询起始日期："+this.starttime);
            console.log(" timeRange 日期："+this.searchTimeRange);

            let timeRange = that.searchTimeRange.split('~');
            c_params.starttime = (new Date(timeRange[0]).getTime());
            c_params.endtime = (new Date(timeRange[1]).getTime());
            
            that.$store.dispatch({
                type: "alarmmanager/serviceurldetails",
                params:c_params
            }).then((res)=>{
                if(res.status == 200){
                    that.errorDataList = res.data.data;
                    console.log(res.data.data)
                    that.failerateDataList = res.data.data;
                    document.getElementById("chartname2").style.height = "500px";
                    that.failrateChart = that.$echarts.init(document.getElementById("chartname2"));
                    let optionA = that.getFailerateOption(this.failerateDataList);
                    that.failrateChart.setOption(optionA);
                }
            });

        },

        
        getFailerateOption(aDataList){
            // 绘制图表配置
            let option = {};
            option = {
                title: {
                    text: '折线图'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data:aDataList.yAxis_legend
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: aDataList.xAxis_date,
                    axisLabel:{formatter:'{value}'}
                },
                yAxis: {
                    type: 'value'
                },
                series:aDataList.yAxis_datelist
            };
            return option
        }
    },
    props:["chartname"],

    computed:{
        ...mapState('alarmmanager', {
            searchP: state => state.searchP,
        })
    },

    mounted() {
        const {query} = this.$route;
        let timenumber =query.timenumber;
        this.handleTimeJump(timenumber,query.searchTimeRange)
        this.drawLine('','')

    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);
    }
}

</script>
 